import { atom } from "recoil";

export const orderSheetFilterState = atom<string>({
  key: "orderSheetFilterState",
  default: "",
});
